<template>
  <div>
    <div class="outdiv">
      <div class="reviewStatsSpan">
        <span>{{ $t("common.paperInfo") }}</span>
        <span
          class="d-ps"
          v-if="
            ruleForm.reviewerStatus == '0' &&
            (ruleForm.evaluationResult == 2 ||
              ruleForm.evaluationResult == null) &&
            $i18n.locale == 'zh'
          "
          >{{ $t("common.Tobereviewed") }}</span
        >
        <span
          class="d-ps"
          v-if="
            ruleForm.reviewerStatus == '0' &&
            (ruleForm.evaluationResult == 2 ||
              ruleForm.evaluationResult == null) &&
            $i18n.locale == 'en'
          "
          >To be reviewed</span
        >
        <span
          class="y-ps"
          v-if="
            ruleForm.reviewerStatus == 1 &&
            (ruleForm.evaluationResult == 2 ||
              ruleForm.evaluationResult == null)
          "
          >{{ $t("common.reviewing") }}</span
        >
        <span
          class="y-ps"
          v-if="
            ruleForm.evaluationResult == 1 || ruleForm.evaluationResult == 3
          "
          >{{ $t("common.Endofreview") }}</span
        >
      </div>
      <div class="outdiv">
        <el-form
          :model="ruleForm"
          ref="ruleForm"
          label-width="120px"
          class="demo-ruleForm"
          label-position="left"
          size="mini"
        >
          <el-form-item :label="$t('common.docCode')">
            <label>{{ ruleForm.docCode }}</label>
          </el-form-item>

          <el-form-item :label="$t('common.paperTitle')">
            <label>{{ ruleForm.title }}</label>
          </el-form-item>

          <el-form-item :label="$t('common.authorInfo')">
            <!--          <label>{{ruleForm.authorInfo}} 待完善待完善 </label>-->
            <div v-for="(item, index) in ruleForm.authorList" :key="index">
              <span>{{ index + 1 }}.</span>
              <span style="display: inline-block; margin-right: 10px">{{
                item.name
              }}</span>
              <span>{{ item.orgName }}</span>
            </div>
          </el-form-item>

          <el-form-item :label="$t('common.Abstract')">
            <label>{{ ruleForm.abstract }}</label>
          </el-form-item>
          <el-form-item :label="$t('common.Keywords')">
            <label>{{ ruleForm.keywords }}</label>
          </el-form-item>

          <el-form-item :label="$t('common.topic')">
            <!--          <label>{{ruleForm.topic}}</label>-->
            <div
              style="margin-top: 5px"
              v-for="(item, index) in ruleForm.topic.split(';')"
              :key="index"
            >
              <p style="line-height: 20px">{{ index + 1 }}.{{ item }}</p>
            </div>
          </el-form-item>
          <el-form-item
            :label="$t('common.forum2')"
            v-if="meetingCode != 'M1455733754860802048'"
          >
            <label>{{ getForum(ruleForm.forum) }}</label>
          </el-form-item>
          <el-form-item :label="$t('common.language')">
            <label v-if="$i18n.locale == 'zh'">{{
              ruleForm.languageName
            }}</label>
            <label
              v-if="$i18n.locale == 'en' && ruleForm.languageName == '英文'"
              >English</label
            >
            <label
              v-if="$i18n.locale == 'en' && ruleForm.languageName == '中文'"
              >Chinese</label
            >
          </el-form-item>

          <el-form-item :label="$t('common.country')">
            <label v-if="$i18n.locale == 'en'">{{
              ruleForm.countryNameEn
            }}</label>
            <label v-else>{{ ruleForm.countryName }}</label>
          </el-form-item>

          <el-form-item :label="$t('common.file')" prop="url">
            <label>{{ ruleForm.fileName }}</label>
            <div>
              <el-button type="primary" @click="downloadSee">{{
                $t("common.preview")
              }}</el-button>
              <el-button type="primary" @click="download">{{
                $t("common.downLoad")
              }}</el-button>
            </div>
          </el-form-item>
          <el-form-item :label="$t('common.isWill')">
            <label v-if="$i18n.locale == 'en'">{{
              ruleForm.isWillReview == 1 ? "Yes" : "No"
            }}</label>
            <label v-else>{{ ruleForm.isWillReview == 1 ? "是" : "否" }}</label>
          </el-form-item>
          <el-form-item
            :label="$t('common.DoubleCommit')"
            v-if="$store.state.dict.doubleSubmissionOrNot == 1"
          >
            <span>{{ ruleForm.isDoubleCommit | yesNo }}</span>
            <div
              style="margin-top: 5px"
              v-show="
                ruleForm.isDoubleCommit == '1' &&
                crSubmissionEntityList.length > 0
              "
              v-for="(item, index) in crSubmissionEntityList"
              :key="index"
            >
              <p style="line-height: 20px">{{ index + 1 }}.{{ item }}</p>
            </div>
          </el-form-item>
        </el-form>
      </div>

      <div v-if="authorityObj.isShow('#19#56#60') && type == 'detail'">
        <common-title :title="$t('common.reviewComments')"></common-title>
        <div>
          <option-box-component
            :docCode="ruleForm.docCode"
            :key="ruleForm.docCode"
          ></option-box-component>
        </div>
      </div>

      <div
        class="reviewDiv"
        v-if="type == 'review' && authorityObj.isShow('#19#56#59')"
      >
        <el-form :model="reviewDataObj" class="" size="mini">
          <el-form-item :label="$t('common.Scoring')">
            <el-select
              v-model="reviewDataObj.score"
              placeholder=""
              style="width: 80px"
            >
              <el-option label="1" value="1"></el-option>
              <el-option label="2" value="2"></el-option>
              <el-option label="3" value="3"></el-option>
              <el-option label="4" value="4"></el-option>
              <el-option label="5" value="5"></el-option>
              <el-option label="6" value="6"></el-option>
              <el-option label="7" value="7"></el-option>
              <el-option label="8" value="8"></el-option>
              <el-option label="9" value="9"></el-option>
              <el-option label="10" value="10"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('common.reviewComments')">
            <el-input
              type="textarea"
              v-model="reviewDataObj.evaluationAdvice"
              maxlength="5500"
              show-word-limit
              :rows="5"
              :placeholder="$t('common.inputReviewComments')"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <el-button
        v-if="
          ruleForm.distributionEvaluationStatus == '0' &&
          authorityObj.isShow('#19#56#58') &&
          $route.name == 'detailPaper'
        "
        type="primary"
        @click="goReview()"
        size="mini"
        >{{ $t("common.toToReviewer") }}</el-button
      >
      <el-button
        v-if="authorityObj.isShow('#19#56#59') && $route.name == 'reviewPaper'"
        type="primary"
        @click="reviewPaperFunc()"
        size="mini"
        >{{ $t("common.commitReview") }}</el-button
      >
      <el-button
        v-if="
          authorityObj.isShow('#19#56#57') &&
          (ruleForm.evaluationResult == 2 ||
            ruleForm.evaluationResult == null) &&
          ruleForm.createUser == currentUserId
        "
        type="primary"
        @click="goEdit()"
        size="mini"
        >{{ $t("common.edit") }}</el-button
      >
      <el-button type="primary" @click="goBack()" size="mini">{{
        $t("common.back")
      }}</el-button>
    </div>
    <!--  删除确认弹框-->
    <h-popup ref="confirm" @confirm="confirmReview">
      <template slot="title">{{ $t("common.tip") }}</template>
      <template slot="tip"> {{ $t("msg.noChangeTips") }}</template>
    </h-popup>
  </div>
</template>

<script>
import commonTitle from "@/components/common/commonTitle";
import userTableComponent from "@/components/paper/userTableComponent"; //用户列表
import typeToName from "@/utils/typeToName";
import config from "@/api/config";
import hPopup from "@/components/common/hPopup";
import optionBoxComponent from "./optionBoxComponent";
export default {
  props: ["type", "id"], // review 评审页  detail 详情页
  mounted() {
    if (this.id) {
      this.requestFormData();
      // this.lookOverOpinionFunc();
    }
  },
  filters: {
    yesNo(d) {
      return typeToName.yesNo(d);
    },
  },
  components: {
    userTableComponent,
    commonTitle,
    hPopup,
    optionBoxComponent,
  },
  data() {
    return {
      meetingCode: localStorage.getItem("meetingCode"),
      authority: "admin", //权限 admin reviewMan user
      uploadUrl: config.baseURL + "/file/upload",
      fileName: "",
      fileList: [],
      requestTopicArr: ["主题1", "主题12", "主题3"],
      crSubmissionEntityList: [],
      ruleForm: {
        docCode: "",
        title: "",
        Abstract: "",
        Keywords: "",
        topicArr: [],
        topic: "",
        forum: "1",
        language: "",
        languageName: "",
        country: "",
        countryName: "",
        file: "",
        url: "",
        isDoubleCommit: "",
        commitContent: "",
        reviewerStatus: "0", // 0 待评审  1已评审。
        distributionEvaluationStatus: "1", // 0 待评审  1已评审。 默认为1
      },
      currentUserId: "",
      forumList: [
        {
          label: "学界论坛/Academic Forum",
          value: "1",
        },
        {
          label: "博士生论坛/Doctoral Student Forum",
          value: "2",
        },
        {
          label: "业界论坛/Industry Forum",
          value: "3",
        },
      ],
      reviewDataObj: {
        score: 1,
        evaluationAdvice: "",
      },
    };
  },

  methods: {
    goBack() {
      this.$router.go(-1);
    },
    goReview() {
      this.$router.push({
        path: "/reviewPaper",
        query: {
          id: this.ruleForm.docCode,
        },
      });
    },
    getForum(value) {
      for (const index in this.forumList) {
        if (Object.hasOwnProperty.call(this.forumList, index)) {
          const el = this.forumList[index];
          if (el.value == value) {
            return el.label;
          }
        }
      }
    },
    //评审按钮相关
    reviewPaperFunc() {
      this.$refs["confirm"].openDialog();
    },
    confirmReview() {
      this.$refs["confirm"].closeDialog();
      const data = {
        docCode: this.ruleForm.docCode,
        evaluationAdvice: this.reviewDataObj.evaluationAdvice,
        evaluationScore: this.reviewDataObj.score,
      };
      this.$api.doNewInsertDocEvaluation(data).then((res) => {
        this.$message.success(this.$t("msg.successMsg"));
        this.$router.push({
          name: "paperReviewManager",
        });
      });
    },
    goEdit() {
      this.$router.push({
        path: "/editPaper",
        query: {
          id: this.ruleForm.docCode,
        },
      });
    },
    download() {
      // window.open(this.ruleForm.fileName)
      let url = this.ruleForm.fileName;
      var form = document.createElement("form");
      document.body.appendChild(form);
      form.method = "get";
      form.action = url;
      form.submit();
    },
    downloadSee() {
      window.open(this.ruleForm.fileName);
    },
    /**
     * 请求相关
     * */
    //请求详情数据
    requestFormData() {
      let that = this;
      let data = {
        docCode: this.id,
      };
      //请求详情信息
      this.$api.selectUploadDocInfo(data).then((res) => {
        if (res.code == 200) {
          that.ruleForm = res.data;
          that.ruleForm.languageName = typeToName.getLanguageName(
            res.data.language
          );
          if (res.data.commitContent.length > 0) {
            that.crSubmissionEntityList = res.data.commitContent.split(";");
          }
          that.requestOrgNameList();
          // console.log(this.ruleForm)
        }
      });
    },
  },
  created() {
    this.currentUserId = localStorage.getItem("userId");
  },
};
</script>

<style scoped lang="scss">
.outdiv {
  width: 800px;
}
//状态
.reviewStatsSpan {
  margin-bottom: 20px;
  span {
    margin-right: 10px;
    height: 20px;
    line-height: 20px;
  }
  .d-ps {
    color: rgb(255, 151, 72);
    border: 1px solid rgb(255, 151, 72);
    padding: 5px 20px;
    border-radius: 5px;
  }
  .y-ps {
    color: rgb(0, 121, 254);
    border: 1px solid rgb(0, 121, 254);
    padding: 5px 20px;
    border-radius: 5px;
  }
}
//评审意见
.box {
  max-height: 460px;
  overflow: auto;

  .box-in {
    border-bottom: 0.5px solid #a8a8b3;
    margin-bottom: 20px;
  }
}
.reviewDiv {
  border: 1px solid #f0f0f0;
  padding: 10px 20px 10px;
}
</style>
